// extracted by mini-css-extract-plugin
module.exports = {"grid":"CardsHome_grid__3vChm","cards":"CardsHome_cards__16eng"};